import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NotificationsComponent } from './home/notifications/notifications.component';
import { FeedComponent } from './home/feed/feed.component';
import { HttpClientModule } from '@angular/common/http';
import { GiftCardsComponent } from './home/gift-cards/gift-cards.component';
import { GiftCardComponent } from './home/gift-cards/gift-card/gift-card.component';
import { DatePipe } from '@angular/common';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { CsvComponent } from './home/csv/csv.component';
import { AnalyticsComponent } from './home/analytics/analytics.component';
import { NgChartsModule } from 'ng2-charts';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapComponent } from './home/feed/map/map.component';
import { SwiperModule } from 'swiper/angular';
import { OrdersComponent } from './home/orders/orders.component';
import { OrdersAdminComponent } from './home/orders-admin/orders-admin.component';
import { BirthdayCardComponent } from './home/orders/birthday-card/birthday-card.component';
import { AnalyticsDummyDataComponent } from './home/analytics-dummy-data/analytics-dummy-data.component';
import { PlaygroundSelectorComponent } from './home/playground-selector/playground-selector.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    NotificationsComponent,
    FeedComponent,
    GiftCardsComponent,
    GiftCardComponent,
    LoadingSpinnerComponent,
    CsvComponent,
    AnalyticsComponent,
    MapComponent,
    OrdersComponent,
    OrdersAdminComponent,
    BirthdayCardComponent,
    AnalyticsDummyDataComponent,
    PlaygroundSelectorComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule, 
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgChartsModule,
    GoogleMapsModule,
    SwiperModule
    
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
